import { Observable } from 'rxjs';
import { getEmotion } from './emotion';

export function fromLayer(document: Document): Observable<HTMLDivElement> {
  return new Observable(subscriber => {
    const layer = createLayer(document);
    document.body.appendChild(layer);

    subscriber.next(layer);

    return () => {
      if (layer.parentNode) {
        layer.parentNode.removeChild(layer);
      }
    };
  });
}

function createLayer(document: Document) {
  const layer = document.createElement('div');

  const { css } = getEmotion(document);
  layer.classList.add(css`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  `);

  return layer;
}
